import { RegisteredListReducer } from "../reducer/RegisteredListReducer";

export const reducer = RegisteredListReducer;
